import React from 'react';

export default function Footer() {
  return (
      <footer style={{ background: '#0d0d0d', padding: '60px 0 32px', color: '#fff' }}>
        <div className="dh-container">
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: '48px', marginBottom: '48px' }} className="footer-grid">
            {/* Brand */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                <img src="/assets/logo.png" alt="Delivery Hub" style={{ height: '50px', objectFit: 'contain', borderRadius: '10px' }} />
              </div>
              <p style={{ fontFamily: "'Inter'", fontSize: '14px', color: '#9e9d95', lineHeight: 1.7, maxWidth: '260px' }}>
                Lebanon's trusted delivery and logistics partner. Domestic delivery. Full fulfillment. Nationwide coverage.
              </p>
              <p style={{ fontFamily: "'Inter'", fontSize: '13px', color: '#5c5c56', marginTop: '20px' }}>
                📧 info@deliveryhub.me
              </p>
            </div>

            {/* Links */}
            {[
              { heading: 'Services', links: ['Domestic Delivery', 'Orders Fulfillment', 'Warehousing & Storage', 'Returns Management', 'Corporate Logistics', 'Full Fulfillment'] },
              { heading: 'Company', links: ['About Us', 'Coverage', 'Careers', 'Blog'] },
              { heading: 'Support', links: ['Track Your Order', 'Get a Quote', 'FAQ', 'Contact Us'] },
            ].map(col => (
                <div key={col.heading}>
                  <p style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: '14px', color: '#fff', marginBottom: '16px', letterSpacing: '0.3px' }}>{col.heading}</p>
                  <ul style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {col.links.map(l => (
                        <li key={l}>
                          <a href="#" style={{ fontFamily: "'Inter'", fontSize: '14px', color: '#9e9d95', transition: 'color 0.2s' }}
                             onMouseEnter={e => e.target.style.color = '#f9d800'}
                             onMouseLeave={e => e.target.style.color = '#9e9d95'}
                          >{l}</a>
                        </li>
                    ))}
                  </ul>
                </div>
            ))}
          </div>

          {/* Bottom bar */}
          <div style={{ borderTop: '1px solid #1e1e1e', paddingTop: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
            <p style={{ fontFamily: "'Inter'", fontSize: '13px', color: '#5c5c56' }}>
              © {new Date().getFullYear()} Delivery Hub. All rights reserved.
            </p>
            <div style={{ display: 'flex', gap: '24px' }}>
              {['Privacy Policy', 'Terms of Service'].map(l => (
                  <a key={l} href="#" style={{ fontFamily: "'Inter'", fontSize: '13px', color: '#5c5c56', transition: 'color 0.2s' }}
                     onMouseEnter={e => e.target.style.color = '#9e9d95'}
                     onMouseLeave={e => e.target.style.color = '#5c5c56'}
                  >{l}</a>
              ))}
            </div>
          </div>
        </div>

        <style>{`
        @media (max-width: 768px) {
          .footer-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 480px) {
          .footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
      </footer>
  );
}